<template>
    <div>
        
        <div v-if="editDisciplina && !dados.id" class="loading-form" style="min-height: 130px;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <el-form @submit.native.prevent="onSubmitDisciplina" v-if="!editDisciplina || dados.id" :model="dados" ref="dados" label-position="top">
            <div v-if="!editDisciplina || dados.id">

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Situação" prop="situacao" :rules="[$requiredChange]" key="situacao">
                            <el-select v-model="dados.situacao">
                                <el-option :key="true" label="ATIVO" :value="true"></el-option>
                                <el-option :key="false" label="INATIVO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Código Censo / INEP" prop="cod_area" :rules="[$requiredBlur]" key="cod_area">
                            <el-input v-model="dados.cod_area" maxlength="191" v-mask="'####'" v-on:blur="formatData('cod_area')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Nome" prop="nome_area" :rules="[$requiredBlur]" key="nome_area">
                            <el-input v-model="dados.nome_area" maxlength="191" v-on:blur="formatData('nome_area')"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <!--
                            A coluna `sigla` já existia no banco e é consumida pela matriz
                            curricular (`MatrizCurricularService`), mas não havia campo no
                            formulário: dava para ver a sigla e não para cadastrá-la.
                        -->
                        <el-form-item label="Sigla" prop="sigla" key="sigla">
                            <el-input v-model="dados.sigla" maxlength="20"
                                placeholder="Ex.: MAT" v-on:blur="formatData('sigla')"></el-input>
                        </el-form-item>
                    </el-col>
                    
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="12" :md="12">
                        <el-form-item label="Categoria da Disciplina" prop="categoria_disciplina_id" key="categoria_disciplina_id">
                            <el-select v-model="dados.categoria_disciplina_id" filterable clearable placeholder="Selecione" style="width: 100%;">
                                <el-option v-for="c in categorias" :key="c.id" :label="c.nome" :value="c.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Ordem no Histórico" prop="ordem_historico" key="ordem_historico">
                            <el-input-number v-model="dados.ordem_historico" :min="0" :step="1" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Carga Horária Anual" prop="carga_horaria_anual" key="carga_horaria_anual">
                            <el-input-number v-model="dados.carga_horaria_anual" :min="0" :step="1" controls-position="right" style="width: 100%;"></el-input-number>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Lança frequência?" prop="utiliza_frequencia" key="utiliza_frequencia">
                            <el-select v-model="dados.utiliza_frequencia" style="width: 100%;">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Lança nota?" prop="utiliza_nota" key="utiliza_nota">
                            <el-select v-model="dados.utiliza_nota" style="width: 100%;">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Mostrar no histórico escolar?" prop="mostra_historico" key="mostra_historico">
                            <el-select v-model="dados.mostra_historico" style="width: 100%;">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Mostrar nas papeletas?" prop="mostra_papeleta" key="mostra_papeleta">
                            <el-select v-model="dados.mostra_papeleta" style="width: 100%;">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Mostrar no parecer descritivo?" prop="mostra_parecer" key="mostra_parecer">
                            <el-select v-model="dados.mostra_parecer" style="width: 100%;">
                                <el-option :key="true" label="SIM" :value="true"></el-option>
                                <el-option :key="false" label="NÃO" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24">
                        <el-form-item class="u-text-right u-mt-15">
                            <el-button type="primary" id="btn-disciplina" native-type="submit">SALVAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>

    </div>
</template>
<script>

export default {
    props: ['paramId'],
    data: () => ({
        editDisciplina: false,
        alert: false,
        categorias: [],
        dados: {
            id: '',
            situacao: '',
            nome_area: '',
            sigla: '',
            cod_area: '',
            categoria_disciplina_id: '',
            ordem_historico: undefined,
            carga_horaria_anual: undefined,
            utiliza_frequencia: true,
            utiliza_nota: true,
            mostra_historico: true,
            mostra_papeleta: true,
            mostra_parecer: true
        }

    }),
    mounted () {

        this.getCategorias();
    },
    methods:{
        getCategorias(){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/categoria-disciplina/getAll`, this.$store.getters.getHeaderAuth).then(response => {

                this.categorias = Array.isArray(response.data) ? response.data : [];

            }).catch((error) => { this.$store.commit('throwException', error); });
        },
        getDisciplinaById(id){

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/getById/` + id, this.$store.getters.getHeaderAuth).then(response => {

                this.dados = JSON.parse(JSON.stringify(response.data));
 
            }).catch((error) => { this.$store.commit('throwException', error); });

        },
        onSubmitDisciplina(){

            document.getElementById("btn-disciplina").focus();

            this.$refs.dados.validate((valid) =>{ if(valid){
 
                window.eventBus.$emit('loading', true);                

                if(this.editDisciplina){

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth).then(response => {

                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});
                        
                        this.$emit('onSubmitDisciplina');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }else{

                    this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/area-conhecimento/store`, this.dados, this.$store.getters.getHeaderAuth).then(response => {
                    
                        window.eventBus.$emit('loading', false);
                        window.eventBus.$emit('alert', {msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success'});

                        this.$emit('onSubmitDisciplina');

                    }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error); });

                }

            }else{
                window.eventBus.$emit('alert', {msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning'});
            }});
        },
        resetFormDisciplina(){
          
            this.dados = { id: '', nome: '', descricao: '', ativa: '', emDestaque: null, imagem: '' };
            this.$refs.dados.clearValidate();
        },
        formatData(field, size = null){

            //TRATA OS INPUTS - LETRA MAIÚCULA 
                        
            if(!this.dados[field])
                return false;

            if(size && this.dados[field].length < size)
                this.dados[field] = '';            

            this.dados[field] = this.dados[field].toUpperCase();

            this.dados[field] = this.$removerAcentos(this.dados[field]);
        }
    },
    watch: {
        paramId: {
            immediate: true,
            handler (value) {

                if(value){

                    this.getDisciplinaById(value);
                    this.editDisciplina = true;
                } 
            }
        },
    }
}
</script>
